import React from 'react';
import { FormGroup, Input, Label } from 'reactstrap';

import 'style/layout/Forms.css';

export default ({
  id,
  label,
  name,
  onChange,
  required,
  value,
  disabled,
}: {
  id: string;
  label: string;
  name?: string;
  onChange: any;
  required?: boolean;
  value: boolean;
  disabled?: boolean;
}): JSX.Element => (
  <FormGroup className="checkbox-form-group">
    <Input
      checked={value}
      className="checkbox-input"
      id={id}
      name={name}
      onChange={onChange}
      required={required === undefined ? false : required}
      type="checkbox"
      disabled={disabled}
    />
    <Label className="label" for={id}>
      {label}
    </Label>
  </FormGroup>
);
